import { useEffect, useState } from 'react'

import { completeMonthsList } from './monthsList'

const useIncomeData = ({ 
    maximumMonthsOld,
    maximumYearsOld,
    monthsOnReverse,
    yearsOnReverse,
    startOnCurrentYear,
    slug,
    payload,
    modifyPayloadKeys
  }) => {
  const [selectedMonth, setSelectedMonth] = useState(null)
  const [monthsList, setMonthsList] = useState(completeMonthsList)
  const [isValidMonth, setIsValidMonth] = useState(true)

  const [selectedYear, setSelectedYear] = useState(null)
  const [yearsList, setYearsList] = useState([])

  const [hasYearsToSelect, setHasYearsToSelect] = useState(true)

  const monthsOldFromYears = (maximumYearsOld * 12)
  const totalMonthsOld = monthsOldFromYears + maximumMonthsOld

  const onChangeYear = (value) => {
    const changedYear = value && selectedYear !== value

    if (changedYear) {
      setSelectedYear(value)
      updateMonthField(value, totalMonthsOld)
    }
  }

  const onChangeMonth = (value) => {
    const changedMonth = value && selectedMonth !== value

    if (changedMonth) {
      setSelectedMonth(value)
      setIsValidMonth(value)
    }
  }

  const updateMonthField = (yearSelected, monthsBackwards) => {
    const months = getSelectableMonths(yearSelected, monthsBackwards)
    const monthsParsed = parseToSelectArray(months, monthsOnReverse)

    const hasSelectedMonth = months.indexOf(selectedMonth) > -1

    if(!hasSelectedMonth && selectedMonth !== null) {
      setSelectedMonth(null)
      setIsValidMonth(false)
    }

    setMonthsList(monthsParsed)
  }

  const updateYearField = (monthsBackwards) => {
    const years = getSelectableYears(monthsBackwards)
    const yearsParsed = parseToSelectArray (years, yearsOnReverse)

    setHasYearsToSelect(yearsParsed.length > 1 || !startOnCurrentYear)
    setYearsList(yearsParsed)
  }

  const parseToSelectArray = (list, reverse) => {
    const mapArrayValues = (item) => ({value: item, label: item})
    const reversedOrderArray = list.map(mapArrayValues)

    return reverse ? reversedOrderArray : reversedOrderArray.reverse()
  }

  const getSelectableDates = (monthsBackwards) => (
    [...Array(monthsBackwards)].map((_, i) => {
      const selectableDate = new Date()
      selectableDate.setMonth(selectableDate.getMonth() - i)
      selectableDate.setHours(0,0,0,0)

      return selectableDate
    })
  )

  const getSelectableMonths = (yearSelected, monthsBackwards) => {
    const filterFromSelectedYear = (item) => (
      item.getFullYear().toString() === yearSelected
    )

    const mapMonthsNumbers = (item) => {
      const monthValue = item.getMonth() + 1
      const monthValueTwoCharacters = monthValue.toString().padStart(2, '0')

      return monthValueTwoCharacters
    }

    return getSelectableDates(monthsBackwards)
      .filter(filterFromSelectedYear)
      .map(mapMonthsNumbers)
  }

  const getSelectableYears = (monthsBackwards) => {
    const mapYearsFromDates = (item) => (item.getFullYear().toString())
    const filterUniqueValues = (item, index, array) => (array.indexOf(item) === index)

    return getSelectableDates(monthsBackwards)
      .map(mapYearsFromDates)
      .filter(filterUniqueValues)
  }

  useEffect(() => {
    updateYearField(totalMonthsOld)

    if (startOnCurrentYear) {
      const currentDate = new Date()
      const currentYear = currentDate.getFullYear().toString()
      onChangeYear(currentYear)
    }

    if (payload?.[slug]) {
      const [currentMonth, currentYear] = payload?.[slug].split('/')
      
      onChangeMonth(currentMonth)
      onChangeYear(currentYear)
    }
  }, [])

  useEffect(() => {
    const parsedDate = selectedMonth && selectedYear ? 
      `${selectedMonth}/${selectedYear}` :
      ''

    const newPayloadData = {
      ...payload,
      [slug]: parsedDate
    }

    modifyPayloadKeys(newPayloadData)
  }, [selectedMonth, selectedYear])

  return {
    selectedMonth,
    selectedYear,
    hasYearsToSelect,
    onChangeMonth,
    onChangeYear,
    monthsList,
    yearsList,
    isValidMonth
  }
}

export default useIncomeData